'use client';

import router from 'next/navigation';
import React, {useContext, PropsWithChildren, ComponentType} from 'react';

import {CommonImageReactElementType, DefaultImage} from './DefaultImage';
import {CommonLinkReactElementType, DefaultLink} from './DefaultLink';
import {DefaultLoading, LoadingProps} from './DefaultLoading';

interface Pushable {
	push: (path: string) => void;
}

export interface CommonComponentContextProps extends PropsWithChildren {
	Image: CommonImageReactElementType;
	Link: CommonLinkReactElementType;
	LoadingComponent: ComponentType<LoadingProps>;
	hygraphMediaDomain: string;
	router: Pushable | typeof router;
	enableAuth: boolean;
	isRTL: boolean;
	locales: string[];
}

export const CommonComponentContext = React.createContext<CommonComponentContextProps>({
	Image: DefaultImage,
	Link: DefaultLink,
	LoadingComponent: DefaultLoading,
	hygraphMediaDomain: 'us-west-2-epicgames.graphassets.com',
	router: {
		push: () => {
			console.log('CommonComponentContext.router() default push handler ');
		}
	},
	isRTL: false,
	enableAuth: true,
	locales: ['en-US']
});

export const useCommonComponentContext = (): CommonComponentContextProps => {
	return useContext<CommonComponentContextProps>(CommonComponentContext);
};
